// extracted by mini-css-extract-plugin
export default {"zoomOutIcon":"ButtonCropZoomOut_zoomOutIcon__mNz0F"};